/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import Chat from "./Chat";

function Fullscreen() {

  return (
    <div className="form-content flex items-center justify-center" id="ai-assistant-fullscreen">
        <Chat fullscreen={true} />
    </div>
  )
}

export default Fullscreen
